module.exports = __webpack_public_path__ + "img/11.32260ae4.png";